<div class="home-button triangle triangle-left" [ngClass]="{'no-breadcrumb d-flex align-items-center' : !breadcrumb}">
  <a [attr.href]="path" [title]="title" class="home-button-link">
    <span *ngIf="!isLoggedIn || !icon" id="defaultHomeIcon" class="icon-el icon-el-m icon-house default-home-icon"></span>
    <img *ngIf="isLoggedIn && icon" [src]="icon" alt="" (error)="icon = null" class="custom-home-icon"/>
  </a>
</div>